/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "/@lib@/commons/registry.js";
import "/@lib@/wsp/wsp_Perms.js";

const r = REG.reg;
r.newPerm("action.wspList#open.wsp", "read.wsp", 0);
r.newPerm("action.dynGen#edit.node", "write.node.update", 4);
r.newPerm("action.itemCodeEd#edit", "write.node.update", 4);
r.newPerm("action.itemXmlEd#edit", "write.node.update", 4);
r.newPerm("action.itemMainView#edit.content", "write.node.update", 4);
r.newPerm("ui.searches.export.items", "read.node.export", 0);
r.newPerm("ui.searches.export.props", "read.node.search", 0);
r.newPerm("action.tasks#create.task", "write.task.create", 0);
r.newPerm("ui.task.fields.deleteBtn", "write.task.delete", 0);
